import { render, staticRenderFns } from "./ProgramsList.vue?vue&type=template&id=de4e7848&"
import script from "./ProgramsList.vue?vue&type=script&lang=js&"
export * from "./ProgramsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports